import React, { useEffect, useState, useRef } from "react";
import FormInput from "../../inputs/FormInput";
import ScreenWrapper from "../../ScreenWrapper";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import {
  createPlayersFunction,
  listPlayersFunction,
  deletePlayersFunction,
} from "../../api/Player";
import {
  createTeamFunction,
  deleteTeamFunction,
  updateTeamFunction,
  listTeamsFunction,
  getTeamsFunction,
} from "../../api/Teams";
import CreateNotifications from "../../Notifications";

function CreatePlayer(props) {
  const [name, setname] = useState(null);
  const [gender, setgender] = useState(null);
  const [selectedteam, setselectedteam] = useState(null);
  const [selectedteamname, setselectedteamname] = useState(null);
  const [teams, setTeams] = useState([]);
  const [age, setAge] = useState(null);
  useEffect(async () => {
    // console.log(props);
    getTeams();
    // const resp = await listPlayersFunction();
    // console.log(resp);
  }, []);

  const createPlayer = async (teamname) => {
    await createPlayersFunction({
      Name: name,
      Gender: gender,
      Age: age,
      TeamName: teamname,
      teamID: selectedteam,
    })
      .then((resp) => {
        if (resp.type === "success") {
          CreateNotifications("success", "Player successfully created");
          props.history.push("/admin/player");
        } else throw resp;
      })
      .catch((err) => {
        CreateNotifications(err.type, err.message);
      });
  };
  const getTeams = async () => {
    const resp = await listTeamsFunction();
    setTeams(resp.data.data.listTeams.items);
    // console.log(resp);
    // console.log(resp.data.data.listTeams);
    // const data = await getTeamsFunction("88d7587b-c0af-4ae9-a30d-bbce569a7677");
    // console.log(data);
  };
  const onformsubmit = async (e) => {
    e.preventDefault();
    var obj = teams.find((o) => o.id == selectedteam);
    var teamname = obj.Name;
    // await setselectedteamname(name);
    // console.log(selectedteamname, name);
    createPlayer(teamname);
    // console.log(name, age, gender, selectedteam, selectedteamname);
  };
  return (
    <ScreenWrapper>
      <Container>
        <Row></Row>
        <Row>
          <Col md={2}></Col>
          <Col md={8}>
            <Card bg={"light"} style={{ width: "100%" }}>
              <Card.Body style={{ textAlign: "center" }}>
                <h5>CREATE PLAYER</h5>
              </Card.Body>
            </Card>
            <Form style={{ margin: "30px" }} onSubmit={(e) => onformsubmit(e)}>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => {
                    setname(e.target.value);
                  }}
                  type="text"
                  placeholder="Enter your Full Name"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicAge">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  value={age}
                  onChange={(e) => {
                    setAge(e.target.value);
                  }}
                  type="number"
                  placeholder="Enter your Age"
                />
                <Form.Text className="text-muted">Enter only numbers</Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Your Gender</Form.Label>
                <Form.Select
                  value={gender}
                  onChange={(e) => {
                    setgender(e.target.value);
                  }}
                  aria-label="Gender"
                  S
                >
                  <option>Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Choose Team</Form.Label>
                <Form.Select
                  value={selectedteam}
                  onChange={(e) => {
                    setselectedteam(e.target.value);
                  }}
                  aria-label="Chose Team"
                >
                  <option>Open this select menu</option>
                  {teams.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.Name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Text className="text-muted">
                  Can't Find Team ?<a href="/admin/team">Create Team</a>{" "}
                </Form.Text>
              </Form.Group>
              <Button
                variant="danger"
                onClick={() => props.history.push("/admin/player")}
                className="mx-3"
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </Col>
          <Col md={{ offset: 2 }}></Col>
        </Row>
      </Container>
    </ScreenWrapper>
  );
}

export default CreatePlayer;
